var SetIgnoreWait = function (value) {    
    this.typeWriter.setIgnoreWait(value);
    return this;
}

export default SetIgnoreWait;